// DS: i3.46
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const MltSearch: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.73246 5.73246L7.92352 5.73246C8.40192 5.73246 8.78975 5.34464 8.78975 4.86623C8.78975 4.38783 8.40192 4 7.92352 4H4.88661C4.39695 4 4 4.39695 4 4.88661V7.92352C4 8.40192 4.38782 8.78975 4.86623 8.78975C5.34464 8.78975 5.73246 8.40192 5.73246 7.92352L5.73246 5.73246Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.6722 14.2372C12.1661 14.5007 11.5908 14.6495 10.9808 14.6495C8.95461 14.6495 7.31206 13.007 7.31206 10.9808C7.31206 8.95461 8.95461 7.31206 10.9808 7.31206C13.007 7.31206 14.6495 8.95461 14.6495 10.9808C14.6495 11.8066 14.3767 12.5686 13.9163 13.1817L15.8643 15.3247C16.1672 15.6579 16.1426 16.1735 15.8094 16.4763C15.4762 16.7792 14.9606 16.7546 14.6577 16.4215L12.6722 14.2372ZM13.019 10.9808C13.019 12.1065 12.1065 13.019 10.9808 13.019C9.85514 13.019 8.94261 12.1065 8.94261 10.9808C8.94261 9.85514 9.85514 8.94261 10.9808 8.94261C12.1065 8.94261 13.019 9.85514 13.019 10.9808Z"
        fill="currentColor"
      />
      <path
        d="M18.2675 18.2675H16.0765C15.5981 18.2675 15.2103 18.6554 15.2103 19.1338C15.2103 19.6122 15.5981 20 16.0765 20H19.1134C19.603 20 20 19.6031 20 19.1134V16.0765C20 15.5981 19.6122 15.2103 19.1338 15.2103C18.6554 15.2103 18.2675 15.5981 18.2675 16.0765V18.2675Z"
        fill="currentColor"
      />
      <path
        d="M7.92352 18.2675H5.73246V16.0765C5.73246 15.5981 5.34464 15.2103 4.86623 15.2103C4.38782 15.2103 4 15.5981 4 16.0765V19.1134C4 19.6031 4.39695 20 4.88661 20H7.92352C8.40192 20 8.78975 19.6122 8.78975 19.1338C8.78975 18.6554 8.40192 18.2675 7.92352 18.2675Z"
        fill="currentColor"
      />
      <path
        d="M16.0765 5.73246L18.2675 5.73246V7.92352C18.2675 8.40192 18.6554 8.78975 19.1338 8.78975C19.6122 8.78975 20 8.40192 20 7.92352V4.88661C20 4.39695 19.603 4 19.1134 4H16.0765C15.5981 4 15.2103 4.38782 15.2103 4.86623C15.2103 5.34464 15.5981 5.73246 16.0765 5.73246Z"
        fill="currentColor"
      />
    </svg>
  </IconWrap>
);
MltSearch.displayName = 'MltSearch';

export default MltSearch;
